// Module
var code = "<div class=\"checker\"> <label data-toggle=\"tooltip\" data-placement=\"bottom\" data-bind=\"text: Name, tooltip: { content: Description ? Description : Name }\"></label> <span class=\"checkedBox\" data-bind=\"css: {checked: Value}\"> <input data-bind=\"checked: Value, attr: { disabled: Disabled }\" type=\"checkbox\"> </span> </div>";
// Exports
export default code;